import { ReactNode, MouseEventHandler } from 'react';

interface ProtectedMediaWrapperProps {
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  /** When true, skips the transparent overlay (needed for video player controls) */
  noOverlay?: boolean;
}

function ProtectedMediaWrapper({
  children,
  className,
  onClick,
  noOverlay,
}: ProtectedMediaWrapperProps) {
  return (
    <div
      className={className}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      draggable={false}
      style={{
        position: 'relative',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none',
      }}
    >
      {children}
      {!noOverlay && (
        <div
          onClick={onClick}
          role={onClick ? 'button' : undefined}
          tabIndex={onClick ? 0 : undefined}
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            cursor: onClick ? 'pointer' : 'default',
          }}
          aria-hidden={!onClick}
        />
      )}
    </div>
  );
}

export default ProtectedMediaWrapper;
